import 'css-chunk:src/calendar/styles.module.scss';export default {
  "calendar": "a8cui-gPJt-U",
  "calendar__day": "a8cui-QCGEeM",
  "calendar__day-button": "a8cui-HDc6At",
  "calendar__caption-label": "a8cui--tMqc-",
  "calendar__button-next": "a8cui-K6-emE",
  "calendar__button-previous": "a8cui-jkKgJ8",
  "calendar__chevron": "a8cui-i7sHUR",
  "calendar__nav": "a8cui-ErX9-L",
  "calendar__month-caption": "a8cui-zh2-ml",
  "calendar__months": "a8cui-uwIn95",
  "calendar__month-grid": "a8cui-qCUnTq",
  "calendar__weekday": "a8cui-4dwCgM",
  "calendar__day--today": "a8cui-OIctzz",
  "calendar__day--selected": "a8cui-Fmweu0",
  "calendar__range-middle": "a8cui-xxeRL-",
  "calendar__day--hidden": "a8cui-hYbR6o",
  "calendar__range-start": "a8cui-QLGSvK",
  "calendar__range-end": "a8cui-yvkr8w",
  "calendar__day--preview": "a8cui-S2KIWp",
  "calendar__weeks-before-enter": "a8cui-EmUC2R",
  "calendar__weeks-before-exit": "a8cui-q2hElq",
  "calendar__weeks-after-enter": "a8cui-EeHaIG",
  "calendar__weeks-after-exit": "a8cui-m-aGE6",
  "calendar__caption-after-enter": "a8cui-IIuJ-M",
  "calendar__caption-after-exit": "a8cui-ADWpzy",
  "calendar__caption-before-enter": "a8cui-KQdZhf",
  "calendar__caption-before-exit": "a8cui--SotkH",
  "slide-in-left": "a8cui-tirChk",
  "slide-out-left": "a8cui-C-6W5i",
  "slide-in-right": "a8cui-xlTpyU",
  "slide-out-right": "a8cui-X-0QGP",
  "fade-in": "a8cui-Dcdew-",
  "fade-out": "a8cui-TmFIT6"
};